import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'
import _imports_1 from '@/app/ui/assets/svg/exclamation-circle-solid.svg'


const _hoisted_1 = { class: "overflow-y-auto h-screen" }
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400 font-montserrat" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Buat Produk Baru ", -1)
const _hoisted_5 = {
  key: 0,
  class: "inline-flex"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("button", { class: "text-white bg-gray-lp-600 px-8 text-12px xxl:text-14px py-2 xxl:py-3 font-bold rounded-md focus:outline-none" }, " Simpan ", -1)
const _hoisted_7 = {
  key: 1,
  class: "inline-flex"
}
const _hoisted_8 = { class: "flex flex-row h-screen py-6" }
const _hoisted_9 = { class: "w-2/3 px-4 text-12px xxl:text-14px" }
const _hoisted_10 = { class: "py-3 w-3/4" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama Tipe Produk", -1)
const _hoisted_12 = { class: "inline-block relative w-full" }
const _hoisted_13 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700" }
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 mr-3",
  alt: "warning"
}, null, -1)
const _hoisted_15 = {
  key: 0,
  class: "text-red-700"
}
const _hoisted_16 = { class: "py-3 w-3/4" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 pb-2" }, " eCargo Product ", -1)
const _hoisted_18 = { class: "flex flex-row w-3/4" }
const _hoisted_19 = { class: "py-3 w-full" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Deskripsi", -1)
const _hoisted_21 = { class: "inline-block relative w-full" }
const _hoisted_22 = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-end px-2 py-4 text-gray-700" }
const _hoisted_23 = { class: "text-12px text-gray-lp-500" }
const _hoisted_24 = { class: "flex flex-col h-full text-12px border-t border-gray-lp-400 my-6 py-6" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "py-3 w-full text-12px xxl:text-14px" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status Produk"),
  /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500 max-w-md" }, " Produk aktif akan masuk dalam daftar jenis pengiriman. Jangan khawatir status dapat di aktifkan atau di non-aktifkan kembali kapan saja ")
], -1)
const _hoisted_26 = { class: "flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "toggle-knob bg-white inline-block" }, null, -1)
const _hoisted_28 = { class: "ml-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "back"
          }),
          _hoisted_4
        ]),
        (_ctx.disableButton)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6
            ]))
          : _createCommentVNode("", true),
        (!_ctx.disableButton)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode(_component_button_fill, {
                title: "Simpan",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOpenSave())),
                class: "px-8 bg-red-lp-300"
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode("div", _hoisted_12, [
              _withDirectives(_createVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.name = $event)),
                type: "text",
                onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.validateName && _ctx.validateName(...args))),
                onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["space"])),
                placeholder: "Masukkan nama tipe produk",
                class: 
                `focus:border-red-lp-100 py-1.5 xxl:py-3 px-4 rounded border ${_ctx.name !==
                  '' && 'uppercase'} focus:outline-none ${_ctx.dataUser.length !==
                  0 &&
                  _ctx.name !== '' &&
                  'border-red-lp-700'} focus:shadow my-1 text-black-lp-300 w-full ${_ctx.isDisabled &&
                  'bg-white'}`
              
              }, null, 34), [
                [_vModelText, _ctx.name]
              ]),
              _withDirectives(_createVNode("div", _hoisted_13, [
                _hoisted_14
              ], 512), [
                [_vShow, _ctx.dataUser.length !== 0 && _ctx.name !== '']
              ])
            ]),
            (_ctx.dataUser.length !== 0 && _ctx.name !== '')
              ? (_openBlock(), _createBlock("span", _hoisted_15, "Nama Tipe Produk sudah digunakan"))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_component_MultipleSelectSearch, {
              options: _ctx.eCargoProductListData,
              modelValue: _ctx.eCargoProduct,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.eCargoProduct = $event)),
              modalTitle: "eCargo Product",
              keyName: "name",
              keyValue: "value",
              placeholder: "Pilih eCargo product"
            }, null, 8, ["options", "modelValue"])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("div", _hoisted_21, [
                _withDirectives(_createVNode("textarea", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.description = $event)),
                  onInput: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.validateDescription && _ctx.validateDescription(...args))),
                  cols: "70",
                  rows: "7",
                  maxlength: "1000",
                  placeholder: "Tulis deskripsi produk disini",
                  class: 
                  `focus:border-red-lp-100
              py-1.5 xxl:py-3 px-4 rounded border focus:outline-none focus:shadow my-1
              text-black-lp-300 w-full ${_ctx.isDisabled && 'bg-white'}`
                
                }, null, 34), [
                  [_vModelText, _ctx.description]
                ]),
                _createVNode("div", _hoisted_22, [
                  _createVNode("p", _hoisted_23, _toDisplayString(_ctx.description.length) + "/1000 ", 1)
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_24, [
            _hoisted_25,
            _createVNode("div", _hoisted_26, [
              _createVNode("div", {
                onClick: _cache[9] || (_cache[9] = () => _ctx.changeRoute()),
                class: 
                `toggle-switch inline-block cursor-pointer ${
                  _ctx.isRoute ? 'toggle-active bg-red-lp-100' : 'bg-gray-lp-200'
                }`
              
              }, [
                _hoisted_27
              ], 2),
              _createVNode("div", _hoisted_28, " Produk " + _toDisplayString(_ctx.isRoute ? "Aktif" : "Tidak Aktif"), 1)
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.onCloseSuccess,
      title: "Buat Produk Baru Selesai",
      message: `Produk ${_ctx.name.toUpperCase()} berhasil dibuat`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin Keluar Halaman ?",
      message: "Anda belum selesai mengisi form. Permintaan tidak akan diproses jika Anda keluar dari halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onCreate,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Pembuatan",
      message: 
      `Anda yakin akan menyimpan produk baru dengan nama ${_ctx.name.toUpperCase()}`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave]
    ])
  ], 64))
}